import { render, staticRenderFns } from "./PublicAudio.vue?vue&type=template&id=598abf4b&scoped=true&"
import script from "./PublicAudio.vue?vue&type=script&lang=js&"
export * from "./PublicAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598abf4b",
  null
  
)

export default component.exports